import { useEffect, useState } from "react";
import "./user.css";
import { FaUser } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { FormControl, FormHelperText, IconButton, InputAdornment, TextField } from "@mui/material";
import { Close, Save, Visibility, VisibilityOff } from "@mui/icons-material";
import UserImage from "../../../assets/Images/user_Image.png"
import Popup from "reactjs-popup";
import MultiSelect from "../../Commen_Component/Popup/MultiSelect";
import { DocType, InputType } from "../../../_enums/enum.services";
import { commanServicer } from "../../Commen_Services/common.services";
import { useLoading } from "../../Loader/LoadingContext";
import { userServicer } from "../../Commen_Services/user.services";
import customToast from "../../Commen_Component/Toast/CustomToast";

interface FormData {
    firstName: string;
    lastName: string;
    mobileNo: string;
    emailId: string;
    company: string;
    userId: string;
    password: string;
    confirmPassword: string;
    selectRoute: string;
    isActive: boolean;
    avatar: string | null;
}

export default function UserForm() {
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
    const MIN_SIZE = 5 * 1024;         
    const MAX_SIZE = 5 * 1024 * 1024; 
    const { pageId } = useParams<{ pageId: string }>();
    const { action } = useParams<{ action: string }>();
    const [isViewData, setIsViewdata] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const [selectedImage, setSelectedImage] = useState<any>(null);
    const [formData, setFormData] = useState<FormData>({
        firstName: "",
        lastName: "",
        mobileNo: "",
        emailId: "",
        company: "",
        userId: "",
        password: "",
        confirmPassword: "",
        selectRoute: "",
        isActive: false,
        avatar: null,
    });
    const [error, setError] = useState({
        firstName: "",
        lastName: "",
        mobileNo: "",
        emailId: "",
        company: "",
        userId: "",
        password: "",
        confirmPassword: "",
        selectRoute: "",
        isActive: false,
        avatar: null,
        ProfileImage:""
    });
    const [showPassword, setShowPassword] = useState(false);
    const [documentList, setDocumentList] = useState<any[]>([]);

    useEffect(() => {
        if (Number(pageId) > 0) {
             loadData();
        }
    }, [pageId]);

    const loadData = async () => {
        const userData = await userServicer.GetUserDetailById(pageId);
        if (userData.status == true) {
            const result = userData.data?.userWiseCompany
                .map((x:any) => x.routeId)      
                .filter(Boolean)       
                .join(","); 
            const name = userData.data?.user.empName.trim().split(" ");
                userData.data.user != null && setFormData({                                                                                                                                       
                firstName: name[0] ?? "",
                lastName: name.slice(1).join(" "),
                mobileNo: userData.data?.user.mobileNo,
                emailId: userData.data?.user.email,
                company: userData.data?.userWiseCompany[0].companyId ? userData.data?.userWiseCompany[0].companyId.toString()  : "" ,
                userId: userData.data?.user.id,
                password: "",
                confirmPassword: "",
                selectRoute: result,
                isActive: userData.data?.user.isActive,
                avatar: null,
            });

            let DocumnetList = userData.data?.documentDetails;
            let profileImage =  DocumnetList.find((item: any) => item.documentTypeId == DocType.EmployeeProfile)
            setSelectedImage(profileImage?.documentPath)
        }
    };

    const handleInputChange = (e: any) => {
        
        const { name, value, type ,checked} = e.target;
        const cleaned = type == 'checkbox' ?  checked : value.trim();
        const inputElement = e.target as HTMLInputElement;

        setFormData((prev) => ({ ...prev, [name]: cleaned }));
        const validators: Record<string, (v: string) => string | null> = {
            firstname: (v) => (v === "" ? "Please enter a valid first name" : null),
            lastName: (v) => (v === "" ? "Please enter a valid last name" : null),
            mobileNo: (v) => {
                const digits = v.replace(/\D/g, "");
                return digits.length !== 10
                    ? "Please enter a valid mobile number"
                    : null;
            },
            emailId: (v) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
                    ? null
                    : "Please enter a valid email",
            password: (v) => {
                if (!v) return null; 
                const passwordRegex =
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
                return passwordRegex.test(v)
                    ? null
                    : "Password must be at least 8 characters and include uppercase, lowercase, number, and special character";
            },
            confirmPassword: (v) => {
             if (!v) return null; 
            return v === formData.password ? null : "Passwords do not match";
        }
    };


          const errorMsg = validators[name]?.(cleaned) ?? "";
        setError((prev) => {
                let newErrors = { ...prev, [name]: errorMsg };

        
            if (name === "password") {
      
                if (formData.confirmPassword) {
            
                const isMatch = cleaned === formData.confirmPassword;
                newErrors.confirmPassword = isMatch ? "" : "Passwords do not match";
                } else {
             
                newErrors.confirmPassword = "";
                }
            }

        return newErrors;
        });
};
    //     setError((prev) => ({
    //         ...prev,
    //         [name]: errorMsg,
    //     }));

    //     // Update form data
    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: type === "checkbox" ? inputElement.checked : value,
    //     }));
    // };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const key = e.key;
        if (
            key === 'Backspace' ||
            key === 'Delete' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Tab'
        ) {
            return;
        }
        if (!/^[a-zA-Z]$/.test(key)) {
            e.preventDefault();
        }
    };

    const handleMobileKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const key = e.key;
        if (
            key === 'Backspace' ||
            key === 'Delete' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Tab'
        ) {
            return;
        }
        if (!/^[0-9]$/.test(key)) {
            e.preventDefault();
        }
    };

    const handleProfileImageUpload = (e: any, documentType: any) => {

        const file = e.target.files[0];
        if(!file) return;
        if (file &&  !ALLOWED_TYPES.includes(file?.type)) {
            setError((prevErrors) => ({ ...prevErrors, ProfileImage: "Invalid file type. Only JPEG, PNG are allowed." }));

            return;
        }
        if (file.size < MIN_SIZE || file.size > MAX_SIZE) {
            setError(prev => ({
                ...prev,
                ProfileImage: "Minimum 5 KB and Maximum 5 MB is allowed"
            }));
            return;
        }
        else {
            setError((prevErrors) => ({ ...prevErrors, ProfileImage: "" }));

            setSelectedImage(URL.createObjectURL(file));
            setDocumentList((values: any) => ([...values, { fileData: file, docType: documentType, documentName: e.target.name }]));
        }


    };

    const handleSave = async (event: any) => {
        const IsValid = validateField();

        if (IsValid) {
            setLoading(true);
            let Objlist: any = [];

            await Promise.all(documentList.map(async (file1: any) => {
                let obj2: any = {};
                let file = file1.fileData;
                const d2 = new Date();
                let ImageName = `${d2.getDay()}_${d2.getMonth()}_${d2.getFullYear()}_${d2.getHours()}_${d2.getMinutes()}_${d2.getSeconds()}_${d2.getMilliseconds()}_${file.name}`;
                let abpath = 'AdminPortal/Employee/';
                let Val1 = await commanServicer.UploadImage(abpath, ImageName, file);
                if (Val1) {
                    obj2.documentName = file.name;
                    obj2.documentTypeId = file1.docType;
                    obj2.documentPath = Val1;
                    Objlist.push(obj2);
                }
            }));

            const arr = formData.selectRoute
                .split(",")
                .map(x => ({
                    employeeId: 1,
                    companyId: Number(formData.company),
                    routeId: Number(x)
                }));

            const payload = {
                "user": {
                    "id": Number(formData.userId),
                    "empName": formData.firstName + " " + formData.lastName,
                    "email": formData.emailId,
                    "userName": formData.emailId,
                    "password": formData.password,
                    "mobileNo": formData.mobileNo,
                    "confirmPassword": formData.confirmPassword,
                    "isActive": formData.isActive,
                    "roleId": 2,
                    "employeeId": Number(formData.userId),
                    "companyId": formData.company,
                    "can_update_price_slab": true,
                    "hasFullRights": false,
                },
                "userWiseCompany": arr,
                "documentDetails": Objlist
                
            }

            const { controller: newController, data: result } = await userServicer.createorupdateuser(payload);
            // loadData();
            
            if (!result.status) {
                customToast.error(result.message);
                setLoading(false);
            }
            else {
                setLoading(false);
                customToast.success(result.message);
                handleConfirmExit();
            }

        }

    };



    const validateField = (): boolean => {
        const cleaned = (v: string) => v?.trim() ?? "";

        const rules: Record<string, (v: string) => string | null> = {
            firstName: (v) => (v === "" ? "Please enter a valid first name" : null),
            lastName: (v) => (v === "" ? "Please enter a valid last name" : null),
            mobileNo: (v) => {
                const digits = v.replace(/\D/g, "");
                return digits.length !== 10
                    ? "Please enter a valid mobile number"
                    : null;
            },
            emailId: (v) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
                    ? null
                    : "Please enter a valid email",
            company: (v) => (v === "" ? "Please select a company" : null),
            selectRoute: (v) => (v === "" ? "Please select a route" : null),
            password: (v) => Number(pageId) > 0 ? null : (v === "" ? "Please enter a password" : null),
            confirmPassword: (v) => Number(pageId) > 0 ? null : (v === "" ? "Please enter confirm password" : null),
        };

        let isValid = true;
        const newErrors: Record<string, string> = {};

        for (const key in rules) {
            const fieldValue = cleaned((formData as any)[key]);
            const error = rules[key](fieldValue);

            if (error) {
                isValid = false;
                newErrors[key] = error;
            }
        }

        setError((prev) => ({
            ...prev,
            ...newErrors,
        }));

        return isValid;
    };


    const handleMouseDownPassword = (event: any) => {
        event.preventDefault(); 
    };
    const handleClickShowPassword = () => setShowPassword(!showPassword);

    const handleClose = () => {
        setShowConfirmation(false);
    };

    const handleConfirmExit = () => {
        navigate("/Report/view/28");
    };

    const handleMultiSelectChange = (
        name: string,
        headerName: string,
        selected: any[]
    ) => {
        let inputData: any[] = [];
        for (var vx = 0; vx < selected.length; vx++) {
            inputData.push(selected[vx].OptionID);
        }
        let inputIds = inputData.map(a => a).join(",")

        setFormData((prev) => ({
            ...prev,
            [name]: inputIds,
        }));
        setError((prev) => ({ ...prev, [name]: "" }))
    };

    return (
        <div>
            <div className="shadow">
                <div className="bg-line">
                    <span className="bg-head"><FaUser /> &nbsp;{Number(pageId) > 0 && action !== 'view' ? <>Update </> : isViewData ? <>View</> : <>Add </>} User</span>
                </div>
                <hr className="colorgraph" />
            </div>
            <div className="form-container">
                <div className="form-wrapper">
                    <div className="form-left">
                        <div className="avatar-section">
                            <div className="avatar-wrapper">
                                {selectedImage ? (
                                    <img
                                        src={selectedImage}
                                        width="100"
                                        className="rounded-circle imaje"
                                        alt="Selected"
                                    />
                                ) : (
                                    <img
                                        src={UserImage}
                                        width="100"
                                        className="rounded-circle imaje"
                                        alt="Default"
                                    />
                                )}
                            </div>
                            <label htmlFor="avatar-input" className="upload-button" >
                                Upload
                            </label>
                            <input
                                id="avatar-input"
                                type="file"
                                className="upload-input"
                                // accept="image/*"
                                accept="image/jpeg, image/png"
                                // onChange={handleAvatarChange}
                                onChange={(event) => handleProfileImageUpload(event, DocType.EmployeeProfile)}

                            />
                            {
                                !!error.ProfileImage && (<span>{error.ProfileImage}</span>)
                            }

                        </div>
                    </div>

                    <div className="form-right">
                        <div className="form-grid">
                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="firstName"
                                    value={formData.firstName}
                                    label="First Name"
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    disabled={Number(pageId) > 0}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.firstName}
                                    error={!!error.firstName}
                                    helperText={error.firstName}
                                    inputProps={{ maxLength: 15 }} 
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.firstName ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.firstName ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.firstName ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="lastName"
                                    value={formData.lastName}
                                    label="Last Name"
                                    onChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.lastName}
                                    error={!!error.lastName}
                                    helperText={error.lastName}
                                    disabled={Number(pageId) > 0}
                                    inputProps={{ maxLength: 15 }} 
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.lastName ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.lastName ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.lastName ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="mobileNo"
                                    value={formData.mobileNo}
                                    label="Mobile No."
                                    onChange={handleInputChange}
                                    onKeyDown={handleMobileKeyDown}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.mobileNo}
                                    error={!!error.mobileNo}
                                    helperText={error.mobileNo}
                                    disabled={Number(pageId) > 0}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.mobileNo ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.mobileNo ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.mobileNo ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            {/* Row 2 */}

                            <div className="form-group">
                                <TextField
                                    id="standard-basic"
                                    variant="standard"
                                    name="emailId"
                                    value={formData.emailId}
                                    label="Email Id"
                                    onChange={handleInputChange}
                                    //focused={!!inputs.employeeCode}
                                    focused={!!formData.emailId}
                                    error={!!error.emailId}
                                    helperText={error.emailId}
                                    disabled={Number(pageId) > 0 && action !== 'view'}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.emailId ? 'red' : undefined
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.emailId ? 'red' : undefined
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.emailId ? '9px' : '12px',

                                        },
                                    }}
                                />
                            </div>

                            <div className="form-group">
                                <FormControl focused={!!formData.company} variant="standard" sx={{ minWidth: 120, }}>
                                    <MultiSelect
                                        name="company"
                                        headerName={"Company"}
                                        label={"Company"}
                                        autoSearchKey={"GetCompanyList"}
                                        selectedValues={formData.company}
                                        onChange={handleMultiSelectChange}
                                        fieldType={InputType.Dropdown}
                                    />
                                    {error.company ? (
                                        <FormHelperText sx={{ color: 'red', fontSize: 9 }}>{error.company}</FormHelperText>
                                    ) : (
                                        <FormHelperText sx={{ color: 'white', fontSize: 9 }}>&nbsp;</FormHelperText>
                                    )}
                                </FormControl>
                            </div>
                            <div className="form-group">

                                <FormControl focused={!!formData.selectRoute} variant="standard" sx={{ minWidth: 120, }}>
                                    <MultiSelect
                                        name="selectRoute"
                                        headerName={"Route"}
                                        label={"Route"}
                                        autoSearchKey={"GetRouteList"}
                                        selectedValues={formData.selectRoute}
                                        onChange={handleMultiSelectChange}
                                        fieldType={InputType.MultiSelect}

                                    />
                                    {error.selectRoute ? (
                                        <FormHelperText sx={{ color: 'red', fontSize: 9 }}>{error.selectRoute}</FormHelperText>
                                    ) : (
                                        <FormHelperText sx={{ color: 'white', fontSize: 9 }}>&nbsp;</FormHelperText>
                                    )}
                                </FormControl>


                            </div>

                            <div className="form-group">

                                <TextField
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    variant="standard"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    fullWidth
                                    focused={!!formData.password}
                                    error={!!error.password}
                                    helperText={error.password}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.password ? 'red' : undefined,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    sx={{
                                                        paddingRight: '18px',
                                                        marginLeft: '8px',
                                                        '& svg': {
                                                            fontSize: '10px',
                                                        },
                                                    }}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.password ? 'red' : undefined,
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.password ? '9px' : '12px',
                                        },
                                    }}
                                />

                            </div>

                            <div className="form-group">
                                <TextField
                                    label="Confirm Password"
                                    type={showPassword ? 'text' : 'password'}
                                    variant="standard"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleInputChange}
                                    fullWidth
                                    focused={!!formData.confirmPassword}
                                    error={!!error.confirmPassword}
                                    helperText={error.confirmPassword}
                                    InputProps={{
                                        readOnly: isViewData,
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '14px',
                                            borderColor: error.password ? 'red' : undefined,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                    sx={{
                                                        paddingRight: '18px',
                                                        marginLeft: '8px',
                                                        '& svg': {
                                                            fontSize: '10px',
                                                        },
                                                    }}
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            color: 'var(--body-main-dark-color)',
                                            fontSize: '12px',
                                            borderColor: error.password ? 'red' : undefined,
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontSize: error.password ? '9px' : '12px',
                                        },
                                    }}
                                />
                            </div>


                        </div>

                        <div className="checkbox-group">
                            <input
                                id="isActive"
                                type="checkbox"
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="isActive">Is Active</label>
                        </div>

                        <div className="form-actions">
                            <button
                                // disabled={countEdit === 1}
                                className={`btn123 ${action == 'view' ? 'inactive' : ''} `} disabled={action == 'view'} onClick={(event) => { event.stopPropagation(); handleSave(event); }} style={{ paddingRight: 12, height: '30px' }}><Save />&nbsp;{Number(pageId) > 0 ? <>Update</> : <>Save</>}</button>&nbsp;

                            <button className={`btn123`} onClick={() => { setShowConfirmation(true) }}  ><Close />&nbsp;Close</button>

                            {showConfirmation && (
                                <Popup contentStyle={{ height: 105, width: 275, padding: 0 }} position='top center' open={showConfirmation} onClose={() => setShowConfirmation(false)}>
                                    <div className="confirmation-modal">
                                        <p>Are you sure you want to exit? <br />(Any unsaved changes will be lost.)</p>
                                        <div className="canel_btns">
                                            <button className="btn123" style={{ marginRight: 10 }} onClick={handleClose}>Cancel</button>
                                            <button className="btn123" style={{ marginLeft: 10 }} onClick={handleConfirmExit}>Yes, Exit</button>
                                        </div>
                                    </div>
                                </Popup>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
